import { render } from "./CardStatic.vue?vue&type=template&id=86e35c3e"
import script from "./CardStatic.vue?vue&type=script&lang=js"
export * from "./CardStatic.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__